/**
 * Interval for checking the authentication session (in milliseconds)
 */
export const AUTHENTICATION_REFRESH_INTERVAL = 1000 * 60 * 2; // 2 minutes

/**
 * Buffer time before the access token expires (in seconds). Used to trigger a
 * refresh before the token actually expires.
 */
export const ACCESS_TOKEN_VALIDITY_BUFFER = 5 * 60; // 5 minutes

export const OIDC_SCOPES = ['openid', 'profile', 'email', 'address', 'private_addresses'];
